import styled from 'styled-components';

export const Lines = styled.div`
  min-height: ${props => `${100 * props.size}px`};
  width: ${props => `${100 / props.divideBy}%`};
  box-shadow: 0 0 0 1px #f5f5f5 inset;
  background-color: ${({ backgroundToBlue }) =>
    backgroundToBlue ? 'rgba(38,128,235, 0.2)' : '#fff'};
  transition: all 950ms;
`;

export const Empty = styled.div``;
